const sortOptions = (rawData) => {
	if (rawData?.message === "No record in DataBase!") {
		return [];
	} else {
		const data = rawData?.page ? rawData?.page : rawData;
		let enhancedRawData = data;
		const filD = data?.filter((each) => each !== null);
		if (filD?.length > 0) {
			if (typeof filD[0] === "object") {
				enhancedRawData = data
					?.filter((each) => each !== null)
					.map((each) => {
						let copiedEach = { ...each };
						if (copiedEach?.name === null) {
							copiedEach.name = "";
						}
						if (copiedEach?.title === null) {
							copiedEach.title = "";
						}
						return copiedEach;
					});
			} else if (typeof filD[0] === "string") {
				enhancedRawData = data?.filter((each) => each !== null);
			}
			const sortedData = enhancedRawData.sort((a, b) => {
				if (typeof a === "object") {
					if (a.name || a.name === "") {
						return a.name.localeCompare(b.name);
					} else if (a.title || a.title === "") {
						return a.title.localeCompare(b.title);
					} else if (a.code || a.code === "") {
						// First, check the data type of a.code and b.code
						if (typeof a.code === "string" && typeof b.code === "string") {
							// If both are strings, use localeCompare
							return a.code.localeCompare(b.code);
						} else if (typeof a.code === "number" && typeof b.code === "number") {
							// If both are numbers, do a numeric comparison
							return a.code - b.code; // Numeric comparison
						} else {
							// If one is a number and the other is a string, convert both to string and compare
							return String(a.code).localeCompare(String(b.code)); // Convert to string
						}
					} else if (a.id || a.id === "") {
						return a.id.localeCompare(b.id);
					}
				} else if (typeof a === "string") {
					return a.localeCompare(b);
				} else {
					return;
				}
			});
			return sortedData;
		} else {
			return [];
		}
	}
};

export default sortOptions;
